export default {
    API_URL: 'https://zed2.dxapi.ca/',
    PUSHER_KEY: 'ccfe1558718cffbab7cc',
    PAGE_TITLE: 'Business Help Center',
    LOGIN_URL: 'https://fb-lg-1002.web.app/login',
};